import api from '../api';

export class CommissionRulesManagement {
  static async getCommissionRules() {
    return api.getApiCall('/api/v1/admins/commissions');
  }

}